import NumberFormat from "react-number-format";

export const SocialSecurityFormatDisplay = ({
  value,
  prefix,
}: {
  value: string | number;
  prefix?: string;
}) => {
  return (
    <NumberFormat
      value={value}
      format="###-##-#####"
      displayType={"text"}
      prefix={prefix}
    />
  );
};
